export const ActionTypes = {
    GET_DIRECTORY_LIST:"GET_DIRECTORY_LIST",
    RESET_STATE: 'RESET_STATE'
};
